module.exports = __webpack_public_path__ + "static/media/Cosa-Obra-Sauvignon.693e8005.jpg";